import React, {Component} from 'react'
import Navbar from './Navbar';
import Footer from './Footer';
import { withRouter } from 'react-router-dom';
import { auth } from '../Authentication/firebase/firebase';

class AiConsulting extends Component {
    componentDidMount() {
        // Option A: Check localStorage for a flag like 'isLoggedIn'
        const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        if (!isLoggedIn) {
          this.props.history.push('/login');
          return; // stop here
        }
    
        // Option B: Also check Firebase auth state
        auth.onAuthStateChanged(user => {
          if (!user) {
            this.props.history.push('/login');
          }
        });
    
        // Scroll to top if user is logged in
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className='faq-grid-layout'>
               <Navbar />
               <div className='top-spacer' />
               <div className='banner'>
                    <div className='banner-container'>
                        <h1>AI Consulting</h1>
                    </div>
               </div>
               <div className='mainsection'>
                    <div className='main-container'>
                        <h1>Consulting and Training: Smart Strategies for Responsible AI adoption</h1>
                        <p>
                            At E&S Solutions, we specialise in helping organisations navigate the evolving landscape of artificial intelligence. Whether you are looking to integrate AI into your workflows, develop ethical AI policies, or upskill your team in AI-driven practices, we provide expert guidance and hands-on training to ensure responsible and effective adoption.
                        </p>
                        <br />
                        <p>
                            <strong><u>Strategic AI Integration</u></strong>
                        </p>
                        <p>
                            AI is a powerful tool—but only when applied strategically. We help you:
                        </p>
                        <ul>
                            <li>
                                <strong>Identify AI opportunities </strong> that add real value to your business operations
                            </li>
                            <li>
                                <strong>Develop a tailored AI roadmap</strong>, ensuring alignment with your business goals
                            </li>
                            <li>
                                <strong>Navigate AI implementation </strong>with expert guidance from strategy to execution
                            </li>
                        </ul>
                        <br />
                        <p>
                            <strong><u>AI Ethics & Governance</u></strong>
                        </p>
                        <p>
                            As AI adoption accelerates, responsible AI use is critical. We provide:
                        </p>
                        <ul>
                            <li>
                                <strong>Ethical AI frameworks </strong>that ensure fairness, transparency, and accountability
                            </li>
                            <li>
                                <strong>Regulatory compliance strategies </strong>for data protection and responsible AI use
                            </li>
                            <li>
                                <strong>Governance policies </strong>tailored to industry-specific AI risks and challenges (Ai Use policy, ethical AI use)
                            </li>
                        </ul>
                        <p>AI Training Services</p>
                        <h1>Data Protection & Privacy in AI </h1>
                        <p>AI-driven processes rely on data—but managing it responsibly is key. We train teams on:</p>
                        <ul>
                            <li>
                                <strong>Data governance best practices </strong>to ensure privacy-first AI applications
                            </li>
                            <li>
                                <strong>Regulatory compliance </strong>across GDPR, AI Act, and sector-specific standards
                            </li>
                            <li>
                                <strong>Risk mitigation strategies </strong>to prevent AI-related privacy breaches
                            </li>
                        </ul>
                        <h1>Prompt Engineering & AI Optimisation</h1>
                        <p>Maximising AI’s potential starts with knowing how to communicate with it. We offer:</p>
                        <ul>
                            <li>
                                <strong>Prompt engineering techniques </strong>to improve AI accuracy and efficiency for E&S workflows
                            </li>
                            <li>
                                <strong>Advanced AI interaction skills </strong>for research, analysis, and automation
                            </li>
                            <li>
                                <strong>Workflow optimisation strategies </strong>to integrate AI seamlessly into daily tasks
                            </li>
                        </ul>
                        <h1>Why Work with us?</h1>
                        <ul>
                            <li>
                                <strong>Industry expertise: </strong>Our team combined AI, E&S and data protection expertise
                            </li>
                            <li>
                                <strong>Practical approach: </strong>We focus on real life problems and real life solutions 
                            </li>
                            <li>
                                <strong>Comprehensive training: </strong>We work through various project phases and workflows to cover everything you might need
                            </li>
                        </ul>
                    </div>
               </div>
               <Footer />
            </div>
        )
    }
}

export default AiConsulting